
import { Vue, Component } from 'vue-property-decorator';
import { getTeamDashboard, TeamDashboard } from '@/api/team';

@Component
export default class TeamDashboardView extends Vue {
  private isLoading = false;

  private vizVisible = false;

  private vizType: 'match' | 'league' = 'match';

  private dashboard: TeamDashboard = {
    matchTotal: 0,
    matchWins: 0,
    matchDraws: 0,
    matchLosses: 0,
    matchWinRate: 0,
    leaguePlayed: 0,
    leagueWins: 0,
    leagueDraws: 0,
    leagueLosses: 0,
    leagueWinRate: 0,
    leaguePoints: 0,
    leagueGoalsFor: 0,
    leagueGoalsAgainst: 0,
    leagueGoalDifference: 0,
    leagueRanking: null,
    mannerScore: 0,
  };

  created(): void {
    const teamUid = this.$route.query.teamUid as string;
    if (teamUid) {
      this.fetchDashboard(teamUid);
    }
  }

  get matchDonutStyle(): object {
    return this.buildDonutStyle(
      this.dashboard.matchWins,
      this.dashboard.matchDraws,
      this.dashboard.matchLosses,
    );
  }

  get leagueDonutStyle(): object {
    return this.buildDonutStyle(
      this.dashboard.leagueWins,
      this.dashboard.leagueDraws,
      this.dashboard.leagueLosses,
    );
  }

  get leaguePointsPct(): number {
    const max = this.dashboard.leaguePlayed * 3;
    if (max === 0) return 0;
    return Math.min(100, Math.round((this.dashboard.leaguePoints / max) * 100));
  }

  private buildDonutStyle(wins: number, draws: number, losses: number): object {
    const total = wins + draws + losses;
    if (total === 0) {
      return { background: 'conic-gradient(#edf0f7 0% 100%)' };
    }
    const winPct = (wins / total) * 100;
    const drawPct = (draws / total) * 100;
    return {
      background: `conic-gradient(
        #3949ab 0% ${winPct}%,
        #aab2cc ${winPct}% ${winPct + drawPct}%,
        #ef5350 ${winPct + drawPct}% 100%
      )`,
    };
  }

  private barPct(val: number, total: number): number {
    if (total === 0) return 0;
    return Math.round((val / total) * 100);
  }

  private openViz(type: 'match' | 'league'): void {
    this.vizType = type;
    this.vizVisible = true;
  }

  private async fetchDashboard(teamUid: string): Promise<void> {
    this.isLoading = true;
    try {
      const res = await getTeamDashboard(teamUid);
      this.dashboard = res.data;
    } finally {
      this.isLoading = false;
    }
  }

  private goBack(): void {
    this.$router.go(-1);
  }
}
